import React from 'react'
import { connect } from 'react-redux'
import filter from 'lodash/filter'
import find from 'lodash/find'
import sortBy from 'lodash/sortBy'
import Icon from '../../misc/Icons'
import { formatDate } from '../../../utils/formatDate'
import { getImageUrl } from '../../../utils/mediaDeliveryUrls'
import { getQuestionBodyLabel } from '../../../utils/getQuestionBodyLabel'
import QuestionCountBadge from '../../uiKit/QuestionCountBadge'

function SearchPreviewPack({
  hit, sets, folders, questions, storePack,
}) {
  const pack = storePack || hit
  const editedAt = pack && pack.clientModified

  const sortedFolders = folders
  const sortedSets = sets
  const sortedQuestions = questions
  const isEmpty = sortedFolders.length === 0 && sortedSets.length === 0 && sortedQuestions.length === 0

  const coverImageUrl = pack && pack.image ?
    getImageUrl(pack.id, { version: pack.image, folderPath: '/repo', format: 'jpg' }) :
    null

  return (
    <div className='searchPreviewPane searchPreviewPane--pack'>
      <div className='searchPreviewPane-header'>
        {coverImageUrl ? (
          <div className='searchPreviewPane-header-coverImage'>
            <img src={coverImageUrl} alt={pack.name || 'Pack cover'} />
          </div>
        ) : (
          <div className='searchPreviewPane-header-icon'>
            <Icon name='search-pack' />
          </div>
        )}
        <div className='searchPreviewPane-header-text'>
          <div className='searchPreviewPane-header-title'>
            {(pack && pack.name) || 'Untitled Pack'}
          </div>
          {pack && pack.description && (
            <div className='searchPreviewPane-header-description'>
              {pack.description}
            </div>
          )}
          <div className='searchPreviewPane-header-meta'>
            <span>{`${sortedSets.length} set${sortedSets.length === 1 ? '' : 's'}`}</span>
            <span>{`${sortedFolders.length} folder${sortedFolders.length === 1 ? '' : 's'}`}</span>
            {pack && pack.rating > 0 && (
              <span>{`★ ${Math.round(pack.rating * 10) / 10}`}</span>
            )}
          </div>
          {editedAt && (
            <div className='searchPreviewPane-header-subtitle'>
              {'Edited '}
              {formatDate(editedAt)}
            </div>
          )}
        </div>
      </div>
      <div className='searchPreviewPane-body searchPreviewPack'>
        {isEmpty ? (
          <div className='searchPreviewPack-empty'>
            <span>Pack has no content</span>
          </div>
        ) : (
          <div className='searchPreviewList'>
            {sortedFolders.map((f) => (
              <div key={f.id} className='searchPreviewList-row searchPreviewList-row--folder'>
                <div className='searchPreviewList-row-icon'>
                  <Icon name={f.readOnly ? 'folder-isbe' : 'folder'} />
                </div>
                <div className='searchPreviewList-row-name'>{f.name || 'Untitled Folder'}</div>
              </div>
            ))}
            {sortedSets.map((s) => (
              <div key={s.id} className='searchPreviewList-row searchPreviewList-row--set'>
                <div className='searchPreviewList-row-icon'>
                  <QuestionCountBadge
                    color='blueLight'
                    size='small'
                    questionCount={Array.isArray(s.questions) ? s.questions.length : 0}
                  />
                </div>
                <div className='searchPreviewList-row-name'>{s.name || 'Untitled Set'}</div>
              </div>
            ))}
            {sortedQuestions.map((q) => (
              <div key={q.id} className='searchPreviewList-row searchPreviewList-row--question'>
                <div className='searchPreviewList-row-icon'>
                  <QuestionCountBadge color='blueLight' size='small' questionCount='–' />
                </div>
                <div className='searchPreviewList-row-name'>{getQuestionBodyLabel(q) || 'Untitled Question'}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

function mapStateToProps(state, ownProps) {
  const id = ownProps.hit && ownProps.hit.id
  if (!id) {
    return {
      sets: [], folders: [], questions: [], storePack: null,
    }
  }
  const setsInPack = sortBy(
    filter(state.sets, (s) => s && s.repo === id && !s.archived),
    (s) => -((s.clientModified && new Date(s.clientModified).getTime()) || 0),
  )
  const foldersInPack = sortBy(
    filter(state.folders, (f) => f && f.repo === id && !f.archived && !f.parent),
    'name',
  )
  // Standalone questions sitting at the pack root (not inside a folder).
  const questionsInPack = sortBy(
    filter(state.questions, (q) => q && q.repo === id && !q.folder && !q.archived),
    (q) => -((q.clientModified && new Date(q.clientModified).getTime()) || 0),
  )
  return {
    sets: setsInPack,
    folders: foldersInPack,
    questions: questionsInPack,
    storePack: find(state.repos, { id }),
  }
}

export default connect(mapStateToProps)(SearchPreviewPack)
